module.exports = __webpack_public_path__ + "static/media/red-chips-create.06d0f8ae.svg";